import { IPublicClientApplication } from "@azure/msal-browser";
import { apiLoginRequest } from "../Config";
import LeaveRequestModel from "../Models/LeaveRequestModel";
import LeaveForbiddenWeekModel from "../Models/LeaveForbiddenWeekModel";

export default class LeaveRequestService {
  msalInstance: IPublicClientApplication;

  constructor(msalInstance: IPublicClientApplication) {
    this.msalInstance = msalInstance;
  }

  public async get(
    year: number | null,
    personId: string | null,
    status: string | null
  ): Promise<LeaveRequestModel[]> {
    const baseUrl = process.env.REACT_APP_API_URL;
    const accessToken = await this.acquireAccessToken();

    const data = await fetch(
      `${baseUrl}/api/LeaveRequests?year=${year}&personid=${personId}&status=${status}`,
      {
        method: "get",
        headers: new Headers({
          Authorization: "Bearer " + accessToken,
        }),
      }
    ).then(function (response) {
      return response.json();
    });

    return data;
  }

  public async upsert(data: LeaveRequestModel): Promise<string> {
    const baseUrl = process.env.REACT_APP_API_URL;
    const accessToken = await this.acquireAccessToken();

    const responseData = await fetch(`${baseUrl}/api/LeaveRequests`, {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + accessToken,
      }),
      body: JSON.stringify(data),
    }).then(function (response) {
      return response?.json();
    });

    return responseData?.error;
  }

  public async getAllForbiddenWeeks(): Promise<LeaveForbiddenWeekModel[]> {
    const baseUrl = process.env.REACT_APP_API_URL;
    const accessToken = await this.acquireAccessToken();

    const data = await fetch(baseUrl + "/api/LeaveForbiddenWeeks", {
      method: "get",
      headers: new Headers({
        Authorization: "Bearer " + accessToken,
      }),
    }).then(function (response) {
      return response.json();
    });

    return data;
  }

  public async upsertForbiddenWeek(data: LeaveForbiddenWeekModel) {
    const baseUrl = process.env.REACT_APP_API_URL;
    const accessToken = await this.acquireAccessToken();

    await fetch(baseUrl + "/api/LeaveForbiddenWeeks", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + accessToken,
      }),
      body: JSON.stringify(data),
    });
  }

  public async deleteForbiddenWeek(data: LeaveForbiddenWeekModel) {
    const baseUrl = process.env.REACT_APP_API_URL;
    const accessToken = await this.acquireAccessToken();

    await fetch(baseUrl + "/api/LeaveForbiddenWeeks", {
      method: "delete",
      headers: new Headers({
        Authorization: "Bearer " + accessToken,
      }),
      body: JSON.stringify(data),
    });
  }

  private async acquireAccessToken() {
    const account = this.msalInstance.getActiveAccount();
    if (!account) {
      throw Error(
        "No active account! Verify a user has been signed in and setActiveAccount has been called."
      );
    }

    const authResult = await this.msalInstance.acquireTokenSilent({
      ...apiLoginRequest,
      account: account,
    });

    return authResult.accessToken;
  }
}
